// frontend/src/api/reset.js
import { apiClient } from './index';

const resetApi = {
  /**
   * Executes the system reset with specific options.
   */
  executeReset: async (options) => {
    return await apiClient.post('/reset/execute', options);
  },

  /**
   * Restores data from a JSON backup object.
   */
  restoreBackup: async (backupData) => {
    return await apiClient.post('/reset/restore', backupData);
  }
};

export { resetApi };